// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","header":"header-8CDiQ","routeType":"routeType-33DIp","days":"days-3xPVV","container":"container-g07Uf"};